module.exports = __webpack_public_path__ + "img/logo_cagliari.2a8d131a.png";